//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { DynamicEntityModel } from './DynamicEntityModel';
  
  export class DynamicDataSetModel extends ModelBase {
      static readonly $typeName = 'DynamicDataSetModel';
      public activeVersionKey: string;
      public draftVersionKey: string;
      public key: string;
      public dataSetIdentifier: string;
      public dataSetVersion: number;
      public name: string;
      public status: string;
      public dynamicEntity: DynamicEntityModel;
      public releasedDate: Date;
      public hasDraft: boolean;
      
  }



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/models/DynamicDataSetModel.ts